export const name = "TAN";
export const summary = `Computes the tangent of \`X\`.`;
export const reference = `
## TAN

Computes the tangent of \`X\`.

\`\`\`
TAN(X)
\`\`\`

### Description

Computes the tangent of X where X is specified in radians. Generates an error if overflow occurs.

| X | TAN(X) |
| --- | --- |
| \`+inf\` | \`NaN\` |
| \`-inf\` | \`NaN\` |
| \`NaN\` | \`NaN\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
